import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Role } from '../../../models/enums';
import { NotificationsService } from '../../../services/notifications.service';
import { AuthService } from '../../auth/auth.service';

export const waAdminGuard: CanActivateFn = async () => {
    const auth = inject(AuthService);
    const router = inject(Router);
    const notificationsService = inject(NotificationsService);

    if (!auth.hasRole([Role.WaAdmin]) || !auth.isWA()) {
        notificationsService.showError('Accès non autorisé');
        await router.navigate(['/']);
        return false;
    }
    



    return true;
}; 